import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { IconButton, Tooltip } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import LastLabeledByBadge from "./LastLabeledByBadge";

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    nbrImagesG: {
      padding: `0 0 4px 0`,
      color: "#8F9DEF",
    },
    enhanced: {
      color: "black",
    },
  });

const NavButton = ({
  title,
  disabled,
  onClick,
  icon: IconComponent,
}: {
  title: string;
  disabled: boolean;
  onClick: () => void;
  icon: React.ElementType;
}) => (
  <Tooltip title={title}>
    <span>
      <IconButton
        disabled={disabled}
        onClick={onClick}
        style={{
          backgroundColor: "#eee",
          marginLeft: 4,
          padding: 4,
          width: 32,
          height: 32,
        }}
      >
        <IconComponent fontSize="small" />
      </IconButton>
    </span>
  </Tooltip>
);

export type LastLabeledByBadgeVariant = "chip" | "text";

interface LabelisationHeadProps {
  classes: { root: string; nbrImagesG: string; enhanced: string };
  itemLabel: string;
  currentIndex: number;
  total: number;
  nomBatch: string;
  lastLabeledBy?: string | null;
  isLabeled?: boolean;
  lastLabeledByVariant?: LastLabeledByBadgeVariant;
  currentIndexNode?: React.ReactNode;
  headerActions?: React.ReactNode;
  onPrevious: () => void;
  onNext: () => void;
  prevDisabled: boolean;
  nextDisabled: boolean;
  prevTitle?: string;
  nextTitle?: string;
}

const LabelisationHead = ({
  classes,
  itemLabel,
  currentIndex,
  total,
  nomBatch,
  lastLabeledBy,
  isLabeled,
  lastLabeledByVariant,
  currentIndexNode,
  headerActions,
  onPrevious,
  onNext,
  prevDisabled,
  nextDisabled,
  prevTitle,
  nextTitle,
}: LabelisationHeadProps) => (
  <Grid
    container
    direction="row"
    justify="space-between"
    alignItems="flex-start"
    className={classes.root}
  >
    <Grid item>
      <Typography className={classNames(classes.nbrImagesG)}>
        {itemLabel}{" "}
        {currentIndexNode ?? (
          <span className={classes.enhanced}>{currentIndex + 1}</span>
        )}
        {" / "}
        <span className={classes.enhanced} style={{ marginRight: 8 }}>
          {total}
        </span>
        du lot{" "}
        <span className={classes.enhanced} style={{ margin: "0 8px" }}>
          {nomBatch}
        </span>
      </Typography>
      {isLabeled && lastLabeledBy && (
        <LastLabeledByBadge
          key={`${currentIndex}-${lastLabeledBy}`}
          lastLabeledBy={lastLabeledBy}
          variant={lastLabeledByVariant}
        />
      )}
    </Grid>
    <Grid item>
      <Grid
        container
        alignItems="center"
        justify="flex-end"
        wrap="nowrap"
        style={{ gap: 2 }}
      >
        {headerActions}
        <NavButton
          title={prevTitle || `${itemLabel} précédente`}
          disabled={prevDisabled}
          onClick={onPrevious}
          icon={ArrowBackIcon}
        />
        <NavButton
          title={nextTitle || `${itemLabel} suivante`}
          disabled={nextDisabled}
          onClick={onNext}
          icon={ArrowForwardIcon}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default withStyles(styles)(LabelisationHead);
